import { useState } from 'react';
import styles from './style.module.scss';

export const FeedCarousel = ({ images }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  if (!images || images.length === 0) {
    return null;
  }

  const handlePrevImage = () => {
    setCurrentImageIndex(prev => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNextImage = () => {
    setCurrentImageIndex(prev => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className={styles.carousel}>
      <img
        className={styles.carouselImage}
        src={images[currentImageIndex]}
        alt="Ação voluntária"
      />
      {images.length > 1 && (
        <>
          <button
            className={`${styles.carouselButton} ${styles.prev}`}
            onClick={handlePrevImage}
            aria-label="Imagem anterior"
          >
            ‹
          </button>
          <button
            className={`${styles.carouselButton} ${styles.next}`}
            onClick={handleNextImage}
            aria-label="Próxima imagem"
          >
            ›
          </button>
        </>
      )}

      <div className={styles.carouselCounter}>
        {currentImageIndex + 1} / {images.length}
      </div>

      {/* {images.length > 1 && (
        <div className={styles.carouselControls}>
          {images.map((_, index) => (
            <button
              key={index}
              type="button"
              className={`${styles.carouselDot} ${index === currentImageIndex ? styles.active : ''}`}
              onClick={() => setCurrentImageIndex(index)}
              aria-label={`Ir para imagem ${index + 1}`}
            />
          ))}
        </div>
      )} */}
    </div>
  );
};
